import instanceAxios from "../config/config";
import { AxiosResponse } from "axios";

interface AchievementListParams {
    page?: number;
    limit?: number;
    searchQuery?: string;
}

// interface deck {
//     _id: string;
//     title: string;
// }

// interface Flashcard {
//     _id: string;
//     title_FC: string;
//     type: string;
//     createdAt: string;
//     deck: deck[];
//     flashcard_count: number;
//     answer: string;
//     image: string;
//     sound: string;
// }

// interface FlashcardListResponse {
//     flashcards: Flashcard[];
//     count: number;
// }

const BASE_URL = `/achievement`;

const AchievementService = {
    createAchievement: (data: any): Promise<AxiosResponse> => {
        return instanceAxios.post(`${BASE_URL}/create`, data, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
    },

    getAchievement: (params?: AchievementListParams): Promise<AxiosResponse> => {
        const queryParams = {
            page: Number(params?.page),
            limit: Number(params?.limit),
            searchQuery: params?.searchQuery
        };
        return instanceAxios.post(`${BASE_URL}/list`, queryParams);
    },

    getAchievementById: (achievement_id: string): Promise<AxiosResponse> => {
        return instanceAxios.get(`${BASE_URL}/${achievement_id}`);
    },

    editAchievement: (data: any): Promise<AxiosResponse> => {
        return instanceAxios.post(`${BASE_URL}/edit`, data, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
    },

    deleteAchievement: (id: string): Promise<AxiosResponse> => {
        return instanceAxios.delete(`${BASE_URL}/${id}`);
    },
};

export default AchievementService;